module.exports = __webpack_public_path__ + "img/full-compare.1f80b25b.jpg";